$(document).ready(function() {
      if($("body").hasClass("template-product-gift-card")){
            $('.template-product-gift-card fieldset .form__label__value, fieldset label span').each(function(){
            var amountText = $(this).text().trim();
            var amount = parseFloat(amountText.replace(/[^0-9.-]+/g, ''));
            if (!isNaN(amount)) {
            var formattedAmount = '₹' + amount.toLocaleString();
            $(this).text(formattedAmount);
            }
            });
            
            $('.variations label').on('click', function() {
            var denomination_price = $(this).find("span").text(); 
            setTimeout(function() {
            $(".gift-card-selected-var").text(denomination_price);
            }, 300);
            });
               
            const intervalId = setInterval(() => {
            const popupBackdrop = document.querySelector('.Rise-popup-backdrop');
            if (popupBackdrop && popupBackdrop.classList.contains('show')) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
            }));
            } 
            }, 100);
      }
 document.addEventListener("product:variant-change", function (evt) {
  const newVariant = event.detail.variant;

  if (newVariant && typeof newVariant.inventory_quantity !== 'undefined') {
    const newQty = newVariant.inventory_quantity;

    // Find the span inside the cstm-inventory-content and update it
    const qtySpan = document.querySelector('.cstm-inventory-content .inventory_quantity');

    if (qtySpan) {
      qtySpan.textContent = newQty;
    } else {
      console.warn('inventory_quantity span not found.');
    }
  } else {
    console.warn('No inventory_quantity on variant.');
  }
setTimeout(() => {
  const getThreshold = document.querySelector(".product-inventory-notice--bar-new.new-threshold");

  if (getThreshold) {

    getThreshold.classList.add("new-threshold-bar");
    console.log(getThreshold);

    const getAttribute = getThreshold.getAttribute("threshold"); 
    console.log("Original attribute:", getAttribute);

    if (getAttribute) {

      let numberValue = parseFloat(getAttribute); 

      console.log("Extracted number:", numberValue);
      if(numberValue >500){
          numberValue = 500;
      }
      let percentValue = (numberValue / 500) * 100;
      const spanInside = getThreshold.querySelector("span");
      if (spanInside) {
        
        spanInside.style.setProperty('width', percentValue + "%", 'important');
      }
    }
  } else {
    console.warn("Element '.new-threshold' not found. load");
  }
}, 1400); 
});





const getThreshold = document.querySelector(".product-inventory-notice--bar-new.new-threshold");
if (getThreshold) {

    getThreshold.classList.add("new-threshold-bar-load");
    console.log(getThreshold);

    const getAttribute = getThreshold.getAttribute("threshold"); 
    console.log("Original attribute:", getAttribute);

    if (getAttribute) {

      let numberValue = parseFloat(getAttribute); 

      console.log("Extracted number:", numberValue);
        if(numberValue >500){
          numberValue = 500;
      }
      let percentValue = (numberValue / 500) * 100;
      const spanInside = getThreshold.querySelector("span");
      if (spanInside) {
        
        spanInside.style.setProperty('width', percentValue + "%", 'important');
      }
    }
  } else {
    console.warn("Element '.new-threshold' not found.");
  }
});



// document.addEventListener("product:variant-change", function (evt) {
//   console.log("Variant-change")
//     const variant = evt.detail.variant;
//     console.log("variant",variant);
//     if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
//         let featuredSrc = variant.featured_media.preview_image.src;

//         // Select the img inside the div with class 'product-single__media-image'
//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             imgEl.src = featuredSrc;
//             imgEl.srcset = featuredSrc;

//             console.log("Updated image src and srcset:", featuredSrc);
//         }
//     } else {
//         console.log("No featured media src found for this variant.");
//     }
// });




// document.addEventListener("product:variant-change", function (evt) {
//     const variant = evt.detail.variant;
//     if (
//         variant.featured_media &&
//         variant.featured_media.preview_image &&
//         variant.featured_media.preview_image.src
//     ) {
//         let featuredSrc = variant.featured_media.preview_image.src;
//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             const currentSrc = imgEl.src;
//             const newSrcAbsolute = new URL(featuredSrc, window.location.origin).href;
//             if (currentSrc === newSrcAbsolute) {
//                 return;
//             }
//             imgEl.src = featuredSrc;
//             imgEl.srcset = featuredSrc;
//         }
//     }
// });





// document.addEventListener("product:variant-change", function (evt) {
//     if (window.innerWidth < 1024) {
//         console.log("Skipping variant change logic on mobile/tablet");
//         return; 
//     }

//     console.log("Variant-change");
//     const variant = evt.detail.variant;

//     if (
//         variant.featured_media &&
//         variant.featured_media.preview_image &&
//         variant.featured_media.preview_image.src
//     ) {
//         let featuredSrc = variant.featured_media.preview_image.src;
//         const newSrcAbsolute = new URL(featuredSrc, window.location.origin).href;

//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             const currentSrc = imgEl.src;

//             if (currentSrc === newSrcAbsolute) {
//                 console.log("Image src already matches. No update needed.");
//             } else {
//                 imgEl.src = featuredSrc;
//                 imgEl.srcset = featuredSrc;
//                 console.log("Updated image src and srcset:", featuredSrc);
//             }
//         }

//         const normalizeShopifyImageUrl = (url) => {
//             return url
//                 .replace(/_[0-9]+x[0-9]+_crop_center/, '')
//                 .split('?')[0];
//         };

//         const all_cstm_elements = document.querySelectorAll('.product-images__slide.product-images__slide-image');
//         const elementsExceptFirst = Array.from(all_cstm_elements).slice(1);

//         elementsExceptFirst.forEach((element, index) => {
//             const img = element.querySelector('img');
//             if (!img) return;

//             const imgSrcAbsolute = new URL(img.src, window.location.origin).href;

//             const normalizedImgSrc = normalizeShopifyImageUrl(imgSrcAbsolute);
//             const normalizedNewSrc = normalizeShopifyImageUrl(newSrcAbsolute);

//             console.log("normalizedImgSrc:", normalizedImgSrc);
//             console.log("normalizedNewSrc:", normalizedNewSrc);

//             if (normalizedImgSrc === normalizedNewSrc) {
//                 console.log(`Removing element #${index + 1} because image src matches featured src.`);
//                 setTimeout(function () {
//                     element.remove();
//                 }, 500);
//             }
//         });

//     } else {
//         console.log("No featured media src found for this variant.");
//     }
// });


document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  if (
    variant.featured_media &&
    variant.featured_media.preview_image &&
    variant.featured_media.preview_image.src
  ) {
    const featuredSrc = variant.featured_media.preview_image.src;
    const imgEl = document.querySelector(".variant_image img");
    if (imgEl) {
      if (imgEl.src === featuredSrc) {
        console.log("Image src matches, no update needed.");
        return;
      } else {
        imgEl.src = featuredSrc;
        imgEl.srcset = `
          ${featuredSrc}_375x469_crop_center.webp 375w,
          ${featuredSrc}_640x800_crop_center.webp 640w,
          ${featuredSrc}_960x1200_crop_center.webp 960w
        `;
        console.log("Updated image src and srcset:", featuredSrc);
      }
    } else {
      console.log("No image element found inside .variant_image.");
    }
  } else {
    console.log("No featured media src found for this variant.");
  }
  

});

document.addEventListener("product:variant-change", function (evt) {
  setTimeout(function(){
     const variant = evt.detail.variant;
  if (
    variant.featured_media &&
    variant.featured_media.preview_image &&
    variant.featured_media.preview_image.src
  ) {
    const featuredSrcmobile = variant.featured_media.preview_image.src;
      const imgElmobile = document.querySelector(".Nav_variant_img img");
    console.log("imgElmobile",imgElmobile);
    if (imgElmobile) {
      if (imgElmobile.src === featuredSrcmobile) {
        console.log("Image src matches, no update needed. Mobile");
        return;
      } else {
        imgElmobile.src = featuredSrcmobile;
        imgElmobile.srcset = `
          ${featuredSrcmobile}_375x469_crop_center.webp 375w,
          ${featuredSrcmobile}_640x800_crop_center.webp 640w,
          ${featuredSrcmobile}_960x1200_crop_center.webp 960w
        `;
        console.log("Updated image src and srcset: Mobile", featuredSrcmobile);
      }
    } else {
      console.log("No image element found inside .variant_image. Mobile ");
    }
  } else {
    console.log("No featured media src found for this variant. Mobile");
  }

    },500)

          const flickityElementMainImg = document.querySelector('#Product-Slider');

      if (flickityElementMainImg && typeof Flickity !== 'undefined') {
        const flktyMainImg = Flickity.data(flickityElementMainImg);
          //  alert(22);
        if (flktyMainImg) {
          flktyMainImg.reloadCells();
          flktyMainImg.resize();
          flktyMainImg.select(0);
        }
      }

});


// document.addEventListener('DOMContentLoaded', function() {
//   const not_change_imgs = Array.from(document.querySelectorAll('.product-images__slide:not(.variant_image)'));
//   not_change_imgs.forEach(img => {
//     console.log(img);
//   });
// });

// document.addEventListener('DOMContentLoaded', function() {
//   const variantSrcDiv = document.querySelector('.cstm-all-variant-src');
//   console.log("variantSrcDiv",variantSrcDiv);
//   const variantSrcText = variantSrcDiv ? variantSrcDiv.innerText : '';
//   const variantUrls = variantSrcText
//     .split('\n')
//     .map(line => line.trim())
//     .filter(line => line && !line.includes('No image'))
//     .map(line => line.split(' - ')[1]);
//    console.log("variantUrls",variantUrls);


//   const notChangeImgs = Array.from(document.querySelectorAll('.product-images__slide:not(.variant_image)'));
//   notChangeImgs.forEach(slide => {
//     const img = slide.querySelector('img');
//     console.log('img',img);
//     if (variantUrls.includes(img.src)) {
//       setTimeout(function(){
//       slide.style.display = 'none';
//       },1000)
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   // Run only on desktop (e.g. width >= 768px)
//   // if (window.innerWidth < 768) {
//   //   console.log('Skipping script on mobile');
//   //   return;
//   // }
//   // Extract unique image ID from filename (e.g. 5132c918-3d78-4273-a15b-c93070121c9b)
//   function extractImageId(url) {
//     try {
//       const cleanUrl = url.split('?')[0]; // remove query string
//       const parts = cleanUrl.split('/');
//       const filename = parts[parts.length - 1]; // get filename
//       const idMatch = filename.match(/_(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})_/);
//       return idMatch ? idMatch[1] : null;
//     } catch (e) {
//       return null;
//     }
//   }
//   // Get all variant image IDs
//   const variantSrcItems = document.querySelectorAll('.cstm-all-variant-src li[data-src]');
//   const variantImageIds = Array.from(variantSrcItems)
//     .map(li => extractImageId(li.getAttribute('data-src')))
//     .filter(id => id);

//   console.log("Variant image IDs:", variantImageIds);

//   // Find and remove slides with matching image IDs
//   const slides = document.querySelectorAll('.product-images__slide:not(.variant_image)');
//   slides.forEach(slide => {
//     const img = slide.querySelector('img');
//     if (img) {
//       const imgId = extractImageId(img.src);
//       console.log('Image ID:', imgId);
//       if (variantImageIds.includes(imgId)) {
//         console.log('Removing slide with image ID:', imgId);
//         slide.remove(); // uncomment to actually remove
//       }
//     }
//   });

//   const slidesMobiles = document.querySelectorAll('.product-thumbnail.product-images__slide-item--variant:not(.Nav_variant_img)');
//     slidesMobiles.forEach(slidesMobile => {
//     const imgMobile = slidesMobile.querySelector('img');
//     if (imgMobile) {
//       const imgIdMobile = extractImageId(imgMobile.src);
//       console.log('Image ID Mobile:', imgIdMobile);
//       if (variantImageIds.includes(imgIdMobile)) {
//         console.log('Removing slide with image ID Mobile:', imgIdMobile);
//         slidesMobile.parentNode.remove();
//       }
//     }
//   });

// });




document.addEventListener('DOMContentLoaded', function () {
  // Extract unique image ID from filename (e.g. 5132c918-3d78-4273-a15b-c93070121c9b)
  function extractImageId(url) {
    try {
      const cleanUrl = url.split('?')[0]; // remove query string
      const parts = cleanUrl.split('/');
      const filename = parts[parts.length - 1]; // get filename
      const idMatch = filename.match(/_(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})_/);
      return idMatch ? idMatch[1] : null;
    } catch (e) {
      return null;
    }
  }

  // Get all variant image IDs
  const variantSrcItems = document.querySelectorAll('.cstm-all-variant-src li[data-src]');
  const variantImageIds = Array.from(variantSrcItems)
    .map(li => extractImageId(li.getAttribute('data-src')))
    .filter(id => id);

  console.log("Variant image IDs:", variantImageIds);

  // Find and remove slides with matching image IDs (desktop)
  const slides = document.querySelectorAll('.product-images__slide:not(.variant_image)');
  slides.forEach(slide => {
    const img = slide.querySelector('img');
    if (img) {
      const imgId = extractImageId(img.src);

      if (variantImageIds.includes(imgId)) {

        slide.remove();
      }
    }
  });



       
      const flickityElementMainImg = document.querySelector('#Product-Slider');

      if (flickityElementMainImg && typeof Flickity !== 'undefined') {
        const flktyMainImg = Flickity.data(flickityElementMainImg);
          //  alert(1);
        if (flktyMainImg) {
          flktyMainImg.reloadCells();
          flktyMainImg.resize();
          flktyMainImg.select(0);
        }
      }
 




  // Find and remove slides with matching image IDs (mobile thumbnails)
  const slidesMobiles = document.querySelectorAll('.product-thumbnail.product-images__slide-item--variant:not(.Nav_variant_img)');
  slidesMobiles.forEach(slidesMobile => {
    const imgMobile = slidesMobile.querySelector('img');
    if (imgMobile) {
      const imgIdMobile = extractImageId(imgMobile.src);
      if (variantImageIds.includes(imgIdMobile)) {
        // Remove the slide item itself
        slidesMobile.parentNode.remove();
      }
    }
  });




 const flickityContainer = document.querySelector('#Product-Thumbnails .product-thumbnail-container--inner');
  if (flickityContainer && typeof Flickity !== 'undefined') {
    const flkty = Flickity.data(flickityContainer); // Get existing Flickity instance
    if (flkty) {
      // alert(2);
      console.log('Reloading Flickity after mobile slide removal');
      flkty.reloadCells();
      flkty.resize();
      flkty.select(0);
    }
  }

});

function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}
waitUntil(() => document.querySelector(".template-new-product .main_container_metafield .size_detail")).then(() => {

      const blocks = document.querySelectorAll('.main_container_metafield .size_detail');

      blocks.forEach((block, index) => {
        const header = block.querySelector('.detail');
        const content = block.querySelector('.metafield-rich_text_field');

        // Inject SVG icon once
        if (!header.querySelector('.cp-acc-icon')) {
          const icon = document.createElement('span');
          icon.className = "cp-acc-icon";
          icon.innerHTML = `
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 0.5L4 3.5L7 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;
          header.appendChild(icon);
        }

        // ✅ Close all by default
        if (index !== 0) content.style.display = "none";
        else block.classList.add("cp-active-accordion"); // first open

        header.addEventListener('click', () => {
          const isActive = block.classList.contains('cp-active-accordion');

          // Close all first
          blocks.forEach(b => {
            //b.classList.remove('cp-active-accordion');
            //b.querySelector('.metafield-rich_text_field').style.display = "none";
          });

          // Toggle selected
          if (!isActive) {
            block.classList.add('cp-active-accordion');
            content.style.display = "block";
          } else {
            block.classList.remove('cp-active-accordion');
            content.style.display = "none";
          }
        });
      });

    });


function waitForElement(selector, callback, timeout = 8000) {
  const start = Date.now();
  const check = () => {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    if (Date.now() - start >= timeout) return;
    requestAnimationFrame(check);
  };
  check();
}


// waitForElement(".CP-video-section", () => {
// waitForElement("[id*=loox_reviews]", () => {
// waitForElement('.cstm_icon_with_content.icon_with_content_wrapper', () => {

//   // SELECT ALL pill bars
//   const pillBars = document.querySelectorAll(".CP-pill");

//   pillBars.forEach((pillBar) => {
//     const pillDelivery  = pillBar.querySelector(".CP-delivery-pill");
//     const pillReview    = pillBar.querySelector(".CP-review-pill");
//     const pillDetail    = pillBar.querySelector(".CP-detail-pill");

//     const videoSection   = document.querySelector("#AddToCart");
//     const reviewSection  = document.querySelector("[id*=loox_reviews]");
//     const detailsSection = document.querySelector('[id*="image_text_pdp"] .main-contaner-image_text');

//     if (!pillDelivery || !pillReview || !pillDetail) {
//       return;
//     }

//     function setActive(pill) {
//       pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
//       pill.classList.add("CP-active");
//     }

// function scrollToVideoSection() {
//   const isMobile = window.innerWidth <= 768;

//   // MOBILE TARGET → #AddToCart
//   if (isMobile) {
//     const videoSection = document.querySelector("#AddToCart");
//     if (!videoSection) return;

//     // const offset = -30;
//      if (document.body.classList.contains('template-product-new-product')) {
//   offset = -30;
// } else if (document.body.classList.contains('template-product-hybrid')) {
//   offset = -17;
// } else if (document.body.classList.contains('template-product-edc-product')) {
//   offset = -5;
// }else if (document.body.classList.contains('template-product-new-product-burgundy-matte')) {
//   offset = -55;
// }
//     const top = videoSection.getBoundingClientRect().top + window.scrollY - offset;

//     window.scrollTo({
//       top,
//       behavior: "smooth"
//     });

//     return; // stop here for mobile
//   }

//   // DESKTOP TARGET → .CP-video-section
//   const target = document.querySelector(".CP-video-section");
//   if (!target) return;

//   const activeBar = document.querySelector('.cstm_icon_with_content.icon_with_content_wrapper[style*="block"]');

//   let targetTop = target.getBoundingClientRect().top + window.scrollY;

//   if (activeBar) {
//     const activeHeight = activeBar.offsetHeight || 0;
//     targetTop -= (activeHeight + 160);
//   }

//   window.scrollTo({
//     top: targetTop,
//     behavior: "smooth"
//   });
// }

// // Call the function
// scrollToVideoSection();




//     // Reviews
//     function scrollToReviews() {
//       const offset = window.innerWidth <= 768 ? 90 : 61;
//       const top = reviewSection.getBoundingClientRect().top + window.scrollY - offset;
//       window.scrollTo({ top, behavior: "smooth" });
//     }

//     // Details
//     function scrollToDetails() {
//       const offset = window.innerWidth <= 768 ? 130 : 140;
//       const top = detailsSection.getBoundingClientRect().top + window.scrollY - offset;
//       window.scrollTo({ top, behavior: "smooth" });
//     }


//     // Attach Events
//     pillDelivery.addEventListener("click", () => {
//       setActive(pillDelivery);
//       scrollToVideoSection();
//     });

//     pillReview.addEventListener("click", () => {
//       setActive(pillReview);
//       scrollToReviews();
//     });

//     pillDetail.addEventListener("click", () => {
//       setActive(pillDetail);
//       scrollToDetails();
//     });
//   });

// });
// });
// });

/* =========================================================
   PILL 1 — DELIVERY / VIDEO SECTION SCROLL
   Independent block. Only depends on .CP-pill existing.
   ========================================================= */
  //  waitForElement(".CP-pill", () => {
  //   const pillBars = document.querySelectorAll(".CP-pill");
  
  //   pillBars.forEach((pillBar) => {
  //     const pillDelivery = pillBar.querySelector(".CP-delivery-pill");
  //     if (!pillDelivery) return;
  
  //     function setActive(pill) {
  //       pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
  //       pill.classList.add("CP-active");
  //     }
  
  //     function scrollToVideoSection() {
  //       const isMobile = window.innerWidth <= 768;
  
  //       // MOBILE TARGET → #AddToCart
  //       if (isMobile) {
  //         const videoSection = document.querySelector("#AddToCart");
  //         if (!videoSection) return;
  
  //         let offset = 0;
  //         if (document.body.classList.contains('template-product-new-product')) {
  //           offset = -30;
  //         } else if (document.body.classList.contains('template-product-hybrid')) {
  //           offset = -17;
  //         } else if (document.body.classList.contains('template-product-edc-product')) {
  //           offset = -5;
  //         } else if (document.body.classList.contains('template-product-new-product-burgundy-matte')) {
  //           offset = -55;
  //         }
  
  //         const top = videoSection.getBoundingClientRect().top + window.scrollY - offset;
  
  //         window.scrollTo({
  //           top,
  //           behavior: "smooth"
  //         });
  
  //         return; // stop here for mobile
  //       }
  
  //       // DESKTOP TARGET → .CP-video-section
  //       const target = document.querySelector(".CP-video-section");
  //       if (!target) return;
  
  //       // NOTE: this lookup is safe even if the element no longer exists in the DOM —
  //       // it just resolves to null and the offset adjustment below is skipped.
  //       const activeBar = document.querySelector('.cstm_icon_with_content.icon_with_content_wrapper[style*="block"]');
  
  //       let targetTop = target.getBoundingClientRect().top + window.scrollY;
  
  //       if (activeBar) {
  //         const activeHeight = activeBar.offsetHeight || 0;
  //         targetTop -= (activeHeight + 160);
  //       }
  
  //       window.scrollTo({
  //         top: targetTop,
  //         behavior: "smooth"
  //       });
  //     }
  
  //     pillDelivery.addEventListener("click", () => {
  //       setActive(pillDelivery);
  //       scrollToVideoSection();
  //     });
  //   });
  // });

  /*
  waitForElement(".CP-pill", () => {
    const pillBars = document.querySelectorAll(".CP-pill");
  
    pillBars.forEach((pillBar) => {
      const pillDelivery = pillBar.querySelector(".CP-delivery-pill");
      if (!pillDelivery) return;
  
      function setActive(pill) {
        pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
        pill.classList.add("CP-active");
      }
  
      function scrollToDeliverySection() {
        const target = document.querySelector('[class*="product_default_accordion-Delivery"]');
        if (!target) return;
  
        // 1. Force the accordion open immediately
        if (!target.hasAttribute('open')) {
          target.setAttribute('open', '');
        }
  
        // 2. Clear any sticky headers/sections by creating a safe cushion above the element
        // If 200px is too much or too little, adjust this single number below
        target.style.scrollMarginTop = "400px";
  
        // 3. Let the native browser engine handle the scroll tracking dynamically
        // This ignores layout shifts caused by the opening animation!
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
  
      pillDelivery.addEventListener("click", () => {
        setActive(pillDelivery);
        scrollToDeliverySection();
      });
    });
  });
  */

  /** 
  waitForElement(".CP-pill", () => {
    const pillBars = document.querySelectorAll(".CP-pill");

    pillBars.forEach((pillBar) => {
      const pillDelivery = pillBar.querySelector(".CP-delivery-pill");
      if (!pillDelivery) return;

      function setActive(pill) {
        pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
        pill.classList.add("CP-active");
      }

      // pick the VISIBLE Delivery accordion, not the first one in the DOM
      function getVisibleDelivery() {
        const all = document.querySelectorAll('[class*="product_default_accordion-Delivery"]');
        return Array.from(all).find(el => el.offsetParent !== null) || all[0];
      }

      function scrollToDeliverySection() {
        const target = getVisibleDelivery();
        if (!target) {
          console.warn("[CP] Delivery section not found.");
          return;
        }

        const details = target.querySelector("details") || target;
        if (!details.hasAttribute("open")) details.setAttribute("open", "");

        const OFFSET = 400;

        const doScroll = () => {
          const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        };

        requestAnimationFrame(() => requestAnimationFrame(doScroll));
      }

      pillDelivery.addEventListener("click", () => {
        setActive(pillDelivery);
        scrollToDeliverySection();
      });
    });
  });
  **/

  waitForElement(".CP-pill", () => {
    document.querySelectorAll(".CP-pill").forEach((pillBar) => {
      const pillDelivery = pillBar.querySelector(".CP-delivery-pill");
      if (!pillDelivery) return;

      const setActive = (pill) => {
        pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
        pill.classList.add("CP-active");
      };

      pillDelivery.addEventListener("click", () => {
        setActive(pillDelivery);
        const all = document.querySelectorAll('[class*="product_default_accordion-Delivery"]');
        const target = Array.from(all).find(el => el.offsetParent !== null) || all[0];
        if (!target) return;
        const details = target.querySelector("details") || target;
        details.setAttribute("open", "");
        requestAnimationFrame(() => requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }));
      });
    });
  });


  /* =========================================================
     PILL 2 — REVIEW SECTION SCROLL
     Independent block. Waits for the loox reviews element.
     ========================================================= */
  waitForElement("[id*=loox_reviews]", () => {
    const pillBars = document.querySelectorAll(".CP-pill");
  
    pillBars.forEach((pillBar) => {
      const pillReview   = pillBar.querySelector(".CP-review-pill");
      const reviewSection = document.querySelector("[id*=loox_reviews]");
  
      if (!pillReview || !reviewSection) return;
  
      function setActive(pill) {
        pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
        pill.classList.add("CP-active");
      }
  
      function scrollToReviews() {
        const offset = window.innerWidth <= 768 ? 90 : 61;
        const top = reviewSection.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
  
      pillReview.addEventListener("click", () => {
        setActive(pillReview);
        scrollToReviews();
      });
    });
  });
  
  
  /* =========================================================
     PILL 3 — DETAILS SECTION SCROLL
     Independent block. Waits for the details/image_text element.
     ========================================================= */
  waitForElement('[id*="image_text_pdp"] .main-contaner-image_text', () => {
    const pillBars = document.querySelectorAll(".CP-pill");
  
    pillBars.forEach((pillBar) => {
      const pillDetail     = pillBar.querySelector(".CP-detail-pill");
      const detailsSection = document.querySelector('[id*="image_text_pdp"] .main-contaner-image_text');
  
      if (!pillDetail || !detailsSection) return;
  
      function setActive(pill) {
        pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
        pill.classList.add("CP-active");
      }
  
      function scrollToDetails() {
        const offset = window.innerWidth <= 768 ? 130 : 140;
        const top = detailsSection.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
  
      pillDetail.addEventListener("click", () => {
        setActive(pillDetail);
        scrollToDetails();
      });
    });
  });


document.addEventListener("DOMContentLoaded", initCPVideoSection);
document.addEventListener("shopify:section:load", initCPVideoSection);

function initCPVideoSection() {
  const wrappers = document.querySelectorAll(".CP-video-wrapper");

  if (!wrappers.length) {
    console.log("⛔ No video wrappers found");
    return;
  }

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const playBtn = wrapper.querySelector(".CP-play-btn");

    if (!video || !playBtn) {
      console.warn("⛔ Missing video or play button");
      return;
    }

    // Force mobile attributes
    video.setAttribute("playsinline", "");
    video.setAttribute("muted", "");
    video.setAttribute("preload", "metadata");

    // Icons
    const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fff"><path d="m380-300 280-180-280-180v360Z"></path></svg>`;
    const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fff"><path d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320Z"></path></svg>`;

    playBtn.addEventListener("click", (e) => {
      e.stopPropagation();

      if (video.paused) {
        video.play().then(() => {
          playBtn.innerHTML = pauseIcon;
        }).catch(err => console.log("Play error:", err));
      } else {
        video.pause();
        playBtn.innerHTML = playIcon;
      }
    });

    // Click wrapper to toggle
    wrapper.addEventListener("click", (e) => {
      if (e.target.closest(".CP-play-btn")) return;

      if (video.paused) {
        video.play().then(() => {
          playBtn.innerHTML = pauseIcon;
        });
      } else {
        video.pause();
        playBtn.innerHTML = playIcon;
      }
    });

    // Auto-pause on scroll out
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
          playBtn.innerHTML = playIcon;
        }
      });
    }, { threshold: 0.25 });

    observer.observe(video);
  });

  console.log("🎉 CP video sections initialized successfully");
}


(function () {
  if (window.innerWidth >= 768) return; // mobile only

  function initVideoAutoplay() {
    const slider = document.querySelector('#Product-Slider');
    if (!slider) return false;

    const flkty = Flickity.data(slider);
    if (!flkty) return false;

    function pauseAllVideos() {
      slider.querySelectorAll('video').forEach(video => {
        video.pause();
      });
    }

    function playActiveVideo() {
      const slide = flkty.selectedElement;
      if (!slide) return;

      const video = slide.querySelector('video');
      if (!video) return;

      // iOS autoplay requirements
      video.muted = true;
      video.playsInline = true;

      try {
        video.currentTime = 0;
      } catch (e) {}

      // iOS Safari needs delayed play AFTER settle
      setTimeout(() => {
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      }, 250);
    }

    // Initial autoplay (very important for iOS)
    setTimeout(playActiveVideo, 500);

    // 🔑 Play video ONLY after Flickity finishes sliding
    flkty.on('settle', function () {
      pauseAllVideos();
      playActiveVideo();
    });

    return true;
  }

  // Wait until Flickity is actually initialized
  function waitForFlickity() {
    if (!initVideoAutoplay()) {
      setTimeout(waitForFlickity, 200);
    }
  }

  waitForFlickity();
})(); 
 


(function CP_NOOE_07_MINICART_ADVANCED() {
  "use strict";
  
  document.body.classList.add('body_MinicartRevamp');

  /* -----------------------------------
     HELPERS
  ----------------------------------- */

  const doc = document;
  const qs = (s, c = doc) => c.querySelector(s);
  const qsa = (s, c = doc) => Array.from(c.querySelectorAll(s));

  const onReady = (selector, cb) => {
    const el = qs(selector);
    if (el) return cb(el);

    const mo = new MutationObserver(() => {
      const node = qs(selector);
      if (node) {
        mo.disconnect();
        cb(node);
      }
    });

    mo.observe(doc.documentElement, { childList: true, subtree: true });
  };

  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      if (doc.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const s = doc.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      doc.head.appendChild(s);
    });
  };

  const loadCSS = (href) => {
    if (!doc.querySelector(`link[href="${href}"]`)) {
      const l = doc.createElement("link");
      l.rel = "stylesheet";
      l.href = href;
      doc.head.appendChild(l);
    }
  };

  const formatMoney = cents =>
    "₹" + (cents / 100).toLocaleString("en-IN");

  const fetchJSON = async url => {
    const res = await fetch(url);
    return res.ok ? res.json() : null;
  };

  /* ---------------- Create Slider ---------------- */

function initFeedbackSlider() {
  const slider = qs(".cp-feedback-inner");
  if (!slider) return;
  if (slider.classList.contains("slick-initialized")) return;

  // Skip if the slider has no measurable width yet (drawer still hidden).
  // Slick + variableWidth needs a visible container to measure slides.
  if (slider.getBoundingClientRect().width === 0) return;

  loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css");
  loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css");
  loadScript("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js")
    .then(() => {
      if (!window.jQuery || !jQuery.fn.slick) return;
      if (slider.classList.contains("slick-initialized")) return;

      jQuery(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        variableWidth: true
      });
    })
    .catch(err => console.error("Slick load failed:", err));
}

function destroyFeedbackSlider() {
  const slider = qs(".cp-feedback-inner");
  if (slider && window.jQuery && jQuery.fn.slick && slider.classList.contains("slick-initialized")) {
    jQuery(slider).slick("unslick");
  }
}

// Watch the cart drawer — initialize the slider whenever the drawer
// becomes visible (class toggle, style change, content swap).
onReady(".cart-drawer", drawer => {
  // Try once in case it's already open
  initFeedbackSlider();

  new MutationObserver(() => {
    // Drawer may have just opened, or contents may have just been re-rendered
    initFeedbackSlider();
  }).observe(drawer, {
    attributes: true,
    attributeFilter: ["class", "style", "aria-hidden", "open"],
    childList: true,
    subtree: true
  });
});


  /* -----------------------------------
     ENHANCE CART ITEMS
  ----------------------------------- */

  function enhanceCartItems() {
	  const items = qsa(".cart-drawer .product-cart-item");
	
	  items.forEach(item => {
	    if (item.dataset.cpEnhanced) return;
	
	    const infoInner = qs(".product-cart-item-info--inner", item);
	    if (!infoInner) return;
	
	    const productLink = qs(".cart-product-link", item);
	    const productURL = productLink?.getAttribute("href") || "";
	
	    /* ---------------- Wrapper Group ---------------- */
	    const groupWrap = doc.createElement("div");
	    groupWrap.className = "quick-removeedit-group";
	
	    /* ---------------- QUICK VIEW ---------------- */
	    const quickBtn = doc.createElement("button");
	    quickBtn.className = "cp-quickview-btn";
	    quickBtn.type = "button";
	    quickBtn.textContent = "Quick View";
	    quickBtn.dataset.url = productURL;
	
	    groupWrap.appendChild(quickBtn);
	
	    /* ---------------- REMOVE + EDIT ---------------- */
	    const removeBtn = qs("a.remove", item);
	
	    if (removeBtn) {
	      const wrap = doc.createElement("div");
	      wrap.className = "removeedit-icons";
	
	      const editBtn = doc.createElement("button");
	      editBtn.className = "cp-edit-btn";
	      editBtn.type = "button";
	      editBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.25H18.75V17.5H1.25V16.25ZM15.875 5.625C16.375 5.125 16.375 4.375 15.875 3.875L13.625 1.625C13.125 1.125 12.375 1.125 11.875 1.625L2.5 11V15H6.5L15.875 5.625ZM12.75 2.5L15 4.75L13.125 6.625L10.875 4.375L12.75 2.5ZM3.75 13.75V11.5L10 5.25L12.25 7.5L6 13.75H3.75Z" fill="black"></path></svg>`;
	      editBtn.dataset.url = productURL;
	      editBtn.dataset.line = removeBtn.dataset.index || "";
	
	      wrap.appendChild(editBtn);
	
	      // Move original remove button instead of cloning
	      wrap.appendChild(removeBtn);
	
	      groupWrap.appendChild(wrap);
	    }
	
	    /* ---------------- Append Group ---------------- */
	    infoInner.appendChild(groupWrap);
	
	    /* ---------------- Optional: Remove Engraving ---------------- */
	    const optionsWrap = qs(".product-cart-item-options", item);
	    if (optionsWrap) {
	      const text = optionsWrap.innerText.toLowerCase();
	      if (
	        text.includes("engraving text") ||
	        text.includes("gift message")
	      ) {
	        // optionsWrap.remove();
	      }
	    }
	
	    item.dataset.cpEnhanced = "true";
	  });
	}

  onReady(".cart-drawer", drawer => {
    enhanceCartItems();

    new MutationObserver(() => enhanceCartItems())
      .observe(drawer, { childList: true, subtree: true });
  });

  /* -----------------------------------
     MODAL CREATION (ONLY ONCE)
  ----------------------------------- */

  function createModal() {
    if (qs(".cp-product-modal")) return;

    const modal = doc.createElement("div");
    modal.className = "cp-product-modal";
    modal.innerHTML = `
      <div class="cp-modal-overlay"></div>
      <div class="cp-modal-content">
        <button class="cp-modal-close">×</button>
        <div class="cp-modal-body"></div>
      </div>
    `;

    doc.body.appendChild(modal);

    modal.addEventListener("click", e => {
      if (
        e.target.classList.contains("cp-modal-overlay") ||
        e.target.classList.contains("cp-modal-close")
      ) {
        modal.classList.remove("active");
      }
    });
  }

  createModal();

  /* -----------------------------------
     BUILD VARIANTS
  ----------------------------------- */

  function buildVariantHTML(product, selectedOptions = []) {
  // helper: is this option value available given the other currently-selected options?
  const isValueAvailable = (optIdx, value) => {
    return product.variants.some(v => {
      if (!v.available) return false;
      const opts = [v.option1, v.option2, v.option3];
      for (let i = 0; i < product.options.length; i++) {
        if (i === optIdx) {
          if (opts[i] !== value) return false;
        } else if (selectedOptions[i] && opts[i] !== selectedOptions[i]) {
          return false;
        }
      }
      return true;
    });
  };

  return `
    <div class="cp-variants">
      ${product.options.map((opt, idx) => `
        <div class="cp-option">
          <label>${opt.name}</label>
          <select data-index="${idx}">
            ${opt.values
              .filter(val => isValueAvailable(idx, val))
              .map(val => `
                <option value="${val}" ${val === selectedOptions[idx] ? "selected" : ""}>
                  ${val}
                </option>
              `).join("")}
          </select>
        </div>
      `).join("")}
    </div>
  `;
}

  function getSelectedVariant(product, selects) {
    const values = selects.map(s => s.value);

    return product.variants.find(v =>
      v.options.every((opt, i) => opt === values[i])
    );
  }

  /* -----------------------------------
     MODAL RENDER
  ----------------------------------- */
	/*
  async function openProductModal(url, isEdit = false, line = null) {
    const modal = qs(".cp-product-modal");
    const body = qs(".cp-modal-body");

    modal.classList.add("active");
    body.innerHTML = "Loading...";

    const product = await fetchJSON(url.split("?")[0] + ".js");
    if (!product) return;

    const variant = product.variants[0];

    body.innerHTML = `
      <div class="cp-modal-grid">
        <img src="${product.images[0]}" />
        <div>
          <h3>${product.title}</h3>
          ${!isEdit ? `
            <div class="cp-price">
              ${formatMoney(variant.price)}
              ${variant.compare_at_price ?
                `<del>${formatMoney(variant.compare_at_price)}</del>` : ""}
            </div>
          ` : ""}
          ${!isEdit ? `<div class="cp-description">${product.description}</div>` : ""}
          ${buildVariantHTML(product)}
          <div class="cp-qty">
            <input type="number" min="1" value="1" />
          </div>
          ${
            isEdit
              ? `<button class="cp-updatecart" data-line="${line}">Update</button>`
              : `<button class="cp-addtocart">Add to Cart</button>
                 <a href="${product.url}" class="cp-viewfull">View Full Details</a>`
          }
        </div>
      </div>
    `;

    initVariantLogic(product, body, isEdit);
  }
  */
  async function openProductModal(url, isEdit = false, line = null) {
	  const modal = qs(".cp-product-modal");
	  const body = qs(".cp-modal-body");
	
	  modal.classList.add("active");
	  body.innerHTML = "Loading...";
	
	  const product = await fetchJSON(url.split("?")[0] + ".js");
	  if (!product) return;
	
	  let cartItem = null;
	
	  if (isEdit && line) {
	    const cart = await fetchJSON("/cart.js");
	    cartItem = cart?.items?.[line - 1];
	  }
	
	  const currentVariant = cartItem
	    ? product.variants.find(v => v.id === cartItem.variant_id)
	    : product.variants[0];
	
	  /* 🔒 ONLY CHECK SPECIAL PRODUCTS WHEN EDITING */
	  let isEngraving = false;
	  let isGift = false;
	
	  if (isEdit) {
	    const titleLower = product.title.toLowerCase();
	    isEngraving = titleLower.includes("engraving") || product.product_type === "engraving";
	    isGift = titleLower.includes("birthday") || titleLower.includes("gift") || product.product_type === "giftit";
	  }
	
	  /* ------------------------------------------------ */
	  /* SPECIAL EDIT UI (ONLY FOR EDIT ICON) */
	  /* ------------------------------------------------ */
	
	  if (isEdit && (isEngraving || isGift)) {
	
	    const existingProperty =
	      cartItem?.properties?.["Engraving Text"] ||
	      cartItem?.properties?.["Gift Message"] ||
	      "";
	
	    body.innerHTML = `
	      <div class="cp-modal-grid">
	        <img src="${currentVariant.featured_image?.src || product.images[0]}" />
	        <div>
	          <h3>${product.title}</h3>
	
	          <div class="cp-custom-field">
						  <label>${isEngraving ? "Engraving Text" : "Gift Message"}</label>
						
						  ${isEngraving ? `
						    <div class="cp-input-error"
						         style="display:none;color:red;font-size:12px;margin-bottom:6px;">
						         Please enter up to 3 characters.
						    </div>
						  ` : ``}
						
						  <input type="text"
						         class="cp-custom-input"
						         ${isEngraving ? 'maxlength="3"' : ''}
						         placeholder="${isEngraving ? 'ABC' : ''}"
						         value="${existingProperty || ""}" />
						</div>

	
	          <div class="cp-qty">
                <button type="button" class="cp-qty-minus" aria-label="Decrease">−</button>
                <input type="number" min="1" value="${cartItem?.quantity || 1}" />
                <button type="button" class="cp-qty-plus" aria-label="Increase">+</button>
	          </div>
	
	          <button class="cp-updatecart"
	                  data-line="${line}">
	                  Update
	          </button>
	        </div>
	      </div>
	    `;
	
	    initVariantLogic(product, body, true, {
	      isEngraving,
	      isGift,
	      line,
	      variantId: currentVariant.id
	    });
	
	    return; // 🚀 STOP HERE
	  }
	
	  /* ------------------------------------------------ */
	  /* NORMAL MODAL (Quick View OR Non-Special Edit) */
	  /* ------------------------------------------------ */
	
	  body.innerHTML = `
	    <div class="cp-modal-grid">
	      <img src="${currentVariant.featured_image?.src || product.images[0]}" />
	      <div>
	        <h3>${product.title}</h3>
	
	        <div class="cp-price">
	          ${formatMoney(currentVariant.price)}
	          ${
	            currentVariant.compare_at_price
	              ? `<del>${formatMoney(currentVariant.compare_at_price)}</del>`
	              : ""
	          }
	        </div>
	
	        ${buildVariantHTML(product, currentVariant.options)}
	
	        <div class="cp-qty">
            <button type="button" class="cp-qty-minus" aria-label="Decrease">−</button>
            <input type="number" min="1" value="${cartItem?.quantity || 1}" />
            <button type="button" class="cp-qty-plus" aria-label="Increase">+</button>
          </div>
	
	        ${
	          isEdit
	            ? `<button class="cp-updatecart"
	                       data-line="${line}">
	                       Update
	               </button>`
	            : `<button class="cp-addtocart">Add to Cart</button>
	               <a href="${product.url}" class="cp-viewfull">
	                 View Full Details
	               </a>`
	        }
	      </div>
	    </div>
	  `;
	
	  initVariantLogic(product, body, isEdit, {
	    isEngraving: false,
	    isGift: false,
	    line,
	    variantId: currentVariant.id
	  });
	}


  /* -----------------------------------
     GLOBAL CLICK HANDLER (MERGED)
  ----------------------------------- */

  doc.addEventListener("click", async e => {

    const quick = e.target.closest(".cp-quickview-btn");
    if (quick) {
      return openProductModal(quick.dataset.url);
    }

    const edit = e.target.closest(".cp-edit-btn");
    if (edit) {
      return openProductModal(edit.dataset.url, true, edit.dataset.line);
    }
  });

  /* -----------------------------------
     VARIANT + CART LOGIC
  ----------------------------------- */
  
 async function refreshCartDrawer() {
  try {
    destroyFeedbackSlider();   // tear down before innerHTML swap

    const res = await fetch("/?sections=cart-drawer");
    const data = await res.json();

    const parser = new DOMParser();
    const html = parser.parseFromString(data["cart-drawer"], "text/html");

    const newDrawer = html.querySelector(".cart-drawer");
    const currentDrawer = document.querySelector(".cart-drawer");

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    enhanceCartItems();
    initFeedbackSlider();      // re-init on the fresh markup
  } catch (err) {
    console.error("Cart refresh failed", err);
  }
}


  function initVariantLogic(product, container, isEdit, ctx = {}) {

    const selects = qsa(".cp-variants select", container);
    const priceWrap = qs(".cp-price", container);
    const img = qs("img", container);

    // start from the actual current variant, not always variants[0]
    let currentVariant =
      product.variants.find(v => v.id === ctx.variantId) || product.variants[0];

    const addBtn    = qs(".cp-addtocart", container);
    const updateBtn = qs(".cp-updatecart", container);

    /* LOADING HELPER — prevents double-clicks */
    const withLoading = async (btn, fn) => {
      if (!btn || btn.disabled) return;
      const originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add("cp-btn-loading");
      btn.innerHTML = `<span class="cp-spinner"></span> Loading...`;
      try {
        await fn();
        // success: leave disabled — modal closes anyway
      } catch (err) {
        console.error(err);
        btn.disabled = false;
        btn.classList.remove("cp-btn-loading");
        btn.innerHTML = originalHTML;
      }
    };

    const updateView = () => {
      const v = getSelectedVariant(product, selects);
      console.log("[variant] selected values:", selects.map(s => s.value), "→ matched variant:", v);
      if (v) {
        currentVariant = v;
        if (priceWrap) priceWrap.innerHTML = formatMoney(v.price);
        if (v.featured_image && img) img.src = v.featured_image.src;
      } else {
        if (priceWrap) priceWrap.innerHTML = "Unavailable";
      }
    };

    selects.forEach(sel => sel.addEventListener("change", updateView));

    /* QUANTITY +/- */
    const qtyInput = qs(".cp-qty input", container);
    const qtyMinus = qs(".cp-qty-minus", container);
    const qtyPlus  = qs(".cp-qty-plus", container);

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener("click", () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) qtyInput.value = current - 1;
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener("click", () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    /* ADD TO CART */
    if (addBtn) {
      addBtn.addEventListener("click", () => withLoading(addBtn, async () => {
        const qty = qs(".cp-qty input", container).value;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: currentVariant.id,
            quantity: qty
          })
        });

        await refreshCartDrawer();
        document.querySelector(".cp-product-modal").classList.remove("active");
      }));
    }

    /* UPDATE EXISTING CART ITEM */
    if (updateBtn) {
      updateBtn.addEventListener("click", () => withLoading(updateBtn, async () => {

        const cartLine = parseInt(updateBtn.dataset.line, 10);
        const qty = parseInt(qs(".cp-qty input", container).value, 10);

        const cart = await fetchJSON("/cart.js");
        const cartItem = cart?.items?.[cartLine - 1];

        if (!cartItem) {
          throw new Error("Cart item not found");
        }

        const variantId = currentVariant.id;
        const inputEl = qs(".cp-custom-input", container);
        const errorEl = qs(".cp-input-error", container);
        let inputValue = inputEl?.value.trim() || "";

        if (cartItem.product_type === "engraving") {
          inputValue = inputValue.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 3);
          if (inputEl) inputEl.value = inputValue;
          if (!inputValue) {
            if (errorEl) errorEl.style.display = "block";
            throw new Error("Empty engraving"); // re-enables button
          } else if (errorEl) {
            errorEl.style.display = "none";
          }
        }

        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: cartLine, quantity: 0 })
        });

        const properties = {};
        if (cartItem.product_type === "engraving") properties["Engraving Text"] = inputValue;
        if (cartItem.product_type === "giftit")    properties["Gift Message"]   = inputValue;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: qty, properties })
        });

        await refreshCartDrawer();
        qs(".cp-product-modal").classList.remove("active");
      }));
    }
  }

})();

(function CP_NOOE_07_MINICART_ADVANCED() {
  "use strict";
  
  document.body.classList.add('body_MinicartRevamp');

  /* -----------------------------------
     HELPERS
  ----------------------------------- */

  const doc = document;
  const qs = (s, c = doc) => c.querySelector(s);
  const qsa = (s, c = doc) => Array.from(c.querySelectorAll(s));

  const onReady = (selector, cb) => {
    const el = qs(selector);
    if (el) return cb(el);
    const mo = new MutationObserver(() => {
      const node = qs(selector);
      if (node) { mo.disconnect(); cb(node); }
    });
    mo.observe(doc.documentElement, { childList: true, subtree: true });
  };

  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      if (doc.querySelector(`script[src="${src}"]`)) { resolve(); return; }
      const s = doc.createElement("script");
      s.src = src; s.onload = resolve; s.onerror = reject;
      doc.head.appendChild(s);
    });
  };

  const loadCSS = (href) => {
    if (!doc.querySelector(`link[href="${href}"]`)) {
      const l = doc.createElement("link");
      l.rel = "stylesheet"; l.href = href;
      doc.head.appendChild(l);
    }
  };

  const formatMoney = cents => "₹" + (cents / 100).toLocaleString("en-IN");

  const fetchJSON = async url => {
    const res = await fetch(url);
    return res.ok ? res.json() : null;
  };

  /* ============ LOOX RATING BADGE (HTML parsing approach) ============ */
  const _looxBadgeCache = {};

  async function renderLooxBadge(ratingHolder, productId, productUrl) {
    if (!ratingHolder) return;

    if (_looxBadgeCache[productId]) {
      ratingHolder.innerHTML = _looxBadgeCache[productId];
      ratingHolder.style.display = "";
      return;
    }

    try {
      const res = await fetch(productUrl);
      if (!res.ok) { ratingHolder.style.display = "none"; return; }
      const html = await res.text();

      const block = html.match(/loox-rating[\s\S]{0,600}?>/);
      if (!block) { ratingHolder.style.display = "none"; return; }

      const ratingMatch = block[0].match(/data-rating=["']([\d.]+)["']/);
      const ratersMatch = block[0].match(/data-raters=["'](\d+)["']/);
      if (!ratingMatch || !ratersMatch) { ratingHolder.style.display = "none"; return; }

      const rating = parseFloat(ratingMatch[1]);
      const count = parseInt(ratersMatch[1], 10);
      if (!rating || !count) { ratingHolder.style.display = "none"; return; }

      const full = Math.round(rating);
      const empty = 5 - full;
      const starFull = `<svg viewBox="0 0 24 24" class="cp-rating-star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#000"/></svg>`;
      const starEmpty = `<svg viewBox="0 0 24 24" class="cp-rating-star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none" stroke="#000" stroke-width="1.5"/></svg>`;

      const output = `<span class="cp-rating-stars">${starFull.repeat(full)}${starEmpty.repeat(empty)}</span><span class="cp-rating-text">${rating.toFixed(1)} (${count})</span>`;

      _looxBadgeCache[productId] = output;
      ratingHolder.innerHTML = output;
      ratingHolder.style.display = "";
    } catch (e) {
      console.warn("[rating] failed:", e);
      ratingHolder.style.display = "none";
    }
  }

  const colorNameToCSS = (name) => {
    const n = (name || "").toLowerCase().trim();
    const map = {
      "black": "#000", "carbon black": "#1a1a1a",
      "white": "#fff", "ivory": "#f5f0e6", "cream": "#f1e9d6",
      "clay": "#b2a59b", "tan": "#d2b48c", "beige": "#d8c3a5",
      "brown": "#6b4423", "olive": "#7d7438",
      "fir green": "#655529", "green": "#2e7d32",
      "navy": "#1f3a5f", "blue": "#3b6ea5", "copen blue": "#526b85", "sky blue": "#87b5d4",
      "red": "#b3261e", "maroon": "#5b1a1a", "burgundy": "#6a2433", "wine": "#722f37",
      "grey": "#9e9e9e", "gray": "#9e9e9e", "silver": "#c0c0c0",
      "gold": "#c8a951", "pink": "#e8a3b0", "yellow": "#e8c547", "orange": "#d97742"
    };
    return map[n] || n;
  };

  const isColorOption = (optName) => /colou?r/i.test(optName || "");

  /* ---------------- Feedback Slider ---------------- */

  function initFeedbackSlider() {
    const slider = qs(".cp-feedback-inner");
    if (!slider) return;
    if (slider.classList.contains("slick-initialized")) return;
    if (slider.getBoundingClientRect().width === 0) return;

    loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css");
    loadCSS("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css");
    loadScript("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js")
      .then(() => {
        if (!window.jQuery || !jQuery.fn.slick) return;
        if (slider.classList.contains("slick-initialized")) return;
        jQuery(slider).slick({
          slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: false,
          infinite: false, autoplay: true, autoplaySpeed: 3000,
          adaptiveHeight: true, variableWidth: true
        });
      })
      .catch(err => console.error("Slick load failed:", err));
  }

  function destroyFeedbackSlider() {
    const slider = qs(".cp-feedback-inner");
    if (slider && window.jQuery && jQuery.fn.slick && slider.classList.contains("slick-initialized")) {
      jQuery(slider).slick("unslick");
    }
  }

  onReady(".cart-drawer", drawer => {
    initFeedbackSlider();
    new MutationObserver(() => initFeedbackSlider()).observe(drawer, {
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "open"],
      childList: true,
      subtree: true
    });
  });

  /* -----------------------------------
     ENHANCE CART ITEMS
  ----------------------------------- */

  function enhanceCartItems() {
    const items = qsa(".cart-drawer .product-cart-item");

    items.forEach(item => {
      if (item.dataset.cpEnhanced) return;

      const infoInner = qs(".product-cart-item-info--inner", item);
      if (!infoInner) return;

      const productLink = qs(".cart-product-link", item);
      const productURL = productLink?.getAttribute("href") || "";

      const groupWrap = doc.createElement("div");
      groupWrap.className = "quick-removeedit-group";

      const quickBtn = doc.createElement("button");
      quickBtn.className = "cp-quickview-btn";
      quickBtn.type = "button";
      quickBtn.textContent = "Quick View";
      quickBtn.dataset.url = productURL;
      groupWrap.appendChild(quickBtn);

      const removeBtn = qs("a.remove", item);
      if (removeBtn) {
        const wrap = doc.createElement("div");
        wrap.className = "removeedit-icons";

        const editBtn = doc.createElement("button");
        editBtn.className = "cp-edit-btn";
        editBtn.type = "button";
        editBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.25H18.75V17.5H1.25V16.25ZM15.875 5.625C16.375 5.125 16.375 4.375 15.875 3.875L13.625 1.625C13.125 1.125 12.375 1.125 11.875 1.625L2.5 11V15H6.5L15.875 5.625ZM12.75 2.5L15 4.75L13.125 6.625L10.875 4.375L12.75 2.5ZM3.75 13.75V11.5L10 5.25L12.25 7.5L6 13.75H3.75Z" fill="black"></path></svg>`;
        editBtn.dataset.url = productURL;
        editBtn.dataset.line = removeBtn.dataset.index || "";

        wrap.appendChild(editBtn);
        wrap.appendChild(removeBtn);
        groupWrap.appendChild(wrap);
      }

      infoInner.appendChild(groupWrap);
      item.dataset.cpEnhanced = "true";
    });
  }

  onReady(".cart-drawer", drawer => {
    enhanceCartItems();
    new MutationObserver(() => enhanceCartItems())
      .observe(drawer, { childList: true, subtree: true });
  });

  /* -----------------------------------
     QUICK VIEW MODAL
  ----------------------------------- */

  function createModal() {
    if (qs(".cp-product-modal")) return;
    const modal = doc.createElement("div");
    modal.className = "cp-product-modal";
    modal.innerHTML = `
      <div class="cp-modal-overlay"></div>
      <div class="cp-modal-content">
        <button class="cp-modal-close">×</button>
        <div class="cp-modal-body"></div>
      </div>
    `;
    doc.body.appendChild(modal);
    modal.addEventListener("click", e => {
      if (e.target.classList.contains("cp-modal-overlay") ||
          e.target.classList.contains("cp-modal-close")) {
        modal.classList.remove("active");
      }
    });
  }
  createModal();

  /* -----------------------------------
     EDIT SIDE PANEL
  ----------------------------------- */

  function createEditPanel() {
    if (qs(".cp-edit-panel")) return;
    const panel = doc.createElement("div");
    panel.className = "cp-edit-panel";
    panel.innerHTML = `
      <div class="cp-edit-overlay"></div>
      <div class="cp-edit-side">
        <div class="cp-edit-head">
          <span>Select options</span>
          <button class="cp-edit-close" type="button" aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M13 1L1 13M13 13L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="cp-edit-content"></div>
      </div>
    `;
    doc.body.appendChild(panel);

    const closePanel = () => panel.classList.remove("active");

    qs(".cp-edit-overlay", panel).addEventListener("click", closePanel);
    qs(".cp-edit-close", panel).addEventListener("click", closePanel);

    doc.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && panel.classList.contains("active")) {
        closePanel();
      }
    });
  }
  createEditPanel();

  /* -----------------------------------
     BUILD VARIANTS (for quick-view dropdowns)
  ----------------------------------- */

  function buildVariantHTML(product, selectedOptions = []) {
    const isValueAvailable = (optIdx, value) => {
      return product.variants.some(v => {
        if (!v.available) return false;
        const opts = [v.option1, v.option2, v.option3];
        for (let i = 0; i < product.options.length; i++) {
          if (i === optIdx) { if (opts[i] !== value) return false; }
          else if (selectedOptions[i] && opts[i] !== selectedOptions[i]) return false;
        }
        return true;
      });
    };

    return `
      <div class="cp-variants">
        ${product.options.map((opt, idx) => `
          <div class="cp-option">
            <label>${opt.name}</label>
            <select data-index="${idx}">
              ${opt.values
                .filter(val => isValueAvailable(idx, val))
                .map(val => `
                  <option value="${val}" ${val === selectedOptions[idx] ? "selected" : ""}>
                    ${val}
                  </option>
                `).join("")}
            </select>
          </div>
        `).join("")}
      </div>
    `;
  }

  function getSelectedVariant(product, selects) {
    const values = selects.map(s => s.value);
    return product.variants.find(v =>
      v.options.every((opt, i) => opt === values[i])
    );
  }

  /* -----------------------------------
     openProductModal — for Quick View AND engraving/gift edit
  ----------------------------------- */

  async function openProductModal(url, isEdit = false, line = null) {
    const modal = qs(".cp-product-modal");
    const body = qs(".cp-modal-body");

    modal.classList.add("active");
    body.innerHTML = "Loading...";

    const product = await fetchJSON(url.split("?")[0] + ".js");
    if (!product) return;

    let cartItem = null;
    if (isEdit && line) {
      const cart = await fetchJSON("/cart.js");
      cartItem = cart?.items?.[line - 1];
    }

    const currentVariant = cartItem
      ? product.variants.find(v => v.id === cartItem.variant_id)
      : product.variants[0];

    let isEngraving = false, isGift = false;
    if (isEdit) {
      const titleLower = product.title.toLowerCase();
      isEngraving = titleLower.includes("engraving") || product.product_type === "engraving";
      isGift = titleLower.includes("birthday") || titleLower.includes("gift") || product.product_type === "giftit";
    }

    if (isEdit && (isEngraving || isGift)) {
      const existingProperty =
        cartItem?.properties?.["Engraving Text"] ||
        cartItem?.properties?.["Gift Message"] ||
        "";

      body.innerHTML = `
        <div class="cp-modal-grid">
          <img src="${currentVariant.featured_image?.src || product.images[0]}" />
          <div>
            <h3>${product.title}</h3>
            <div class="cp-custom-field">
              <label>${isEngraving ? "Engraving Text" : "Gift Message"}</label>
              ${isEngraving ? `
                <div class="cp-input-error" style="display:none;color:red;font-size:12px;margin-bottom:6px;">
                  Please enter up to 3 characters.
                </div>
              ` : ``}
              <input type="text" class="cp-custom-input"
                     ${isEngraving ? 'maxlength="3"' : ''}
                     placeholder="${isEngraving ? 'ABC' : ''}"
                     value="${existingProperty || ""}" />
            </div>
            <div class="cp-qty">
              <button type="button" class="cp-qty-minus" aria-label="Decrease">−</button>
              <input type="number" min="1" value="${cartItem?.quantity || 1}" />
              <button type="button" class="cp-qty-plus" aria-label="Increase">+</button>
            </div>
            <button class="cp-updatecart" data-line="${line}">Update</button>
          </div>
        </div>
      `;

      initVariantLogic(product, body, true, {
        isEngraving, isGift, line, variantId: currentVariant.id
      });
      return;
    }

    body.innerHTML = `
      <div class="cp-modal-grid">
        <img src="${currentVariant.featured_image?.src || product.images[0]}" />
        <div>
          <h3>${product.title}</h3>
          <div class="cp-price">
            ${formatMoney(currentVariant.price)}
            ${currentVariant.compare_at_price
              ? `<del>${formatMoney(currentVariant.compare_at_price)}</del>`
              : ""}
          </div>
          ${buildVariantHTML(product, currentVariant.options)}
          <div class="cp-qty">
            <button type="button" class="cp-qty-minus" aria-label="Decrease">−</button>
            <input type="number" min="1" value="${cartItem?.quantity || 1}" />
            <button type="button" class="cp-qty-plus" aria-label="Increase">+</button>
          </div>
          <button class="cp-addtocart">Add to Cart</button>
          <a href="${product.url}" class="cp-viewfull">View Full Details</a>
        </div>
      </div>
    `;

    initVariantLogic(product, body, false, {
      isEngraving: false, isGift: false, line, variantId: currentVariant.id
    });
  }

  /* -----------------------------------
     openEditPanel
  ----------------------------------- */

  async function openEditPanel(url, line) {
    const panel = qs(".cp-edit-panel");
    const content = qs(".cp-edit-content", panel);

    panel.classList.add("active");
    content.innerHTML = `<div class="cp-edit-loading">Loading...</div>`;

    const product = await fetchJSON(url.split("?")[0] + ".js");
    if (!product) return;

    const cart = await fetchJSON("/cart.js");
    const cartLine = parseInt(line, 10);
    const cartItem = cart?.items?.[cartLine - 1];
    if (!cartItem) {
      console.error("[edit-panel] cart item not found");
      return;
    }

    let currentVariant = product.variants.find(v => v.id === cartItem.variant_id)
                       || product.variants[0];
    let selectedOptions = currentVariant.options.slice();

    const media = [];

    if (product.media && product.media.length) {
      product.media.forEach(m => {
        if (m.media_type === "video") {
          const mp4 = m.sources?.find(s => s.format === "mp4") || m.sources?.[0];
          if (mp4?.url) {
            media.push({ type: "video", src: mp4.url, poster: m.preview_image?.src || "" });
          }
        } else if (m.media_type === "external_video") {
          if (m.external_id) {
            media.push({
              type: "external_video",
              host: m.host,
              externalId: m.external_id,
              poster: m.preview_image?.src || ""
            });
          }
        } else {
          const src = m.src || m.preview_image?.src;
          if (src) media.push({ type: "image", src });
        }
      });
    }

    if (!media.length && product.images && product.images.length) {
      product.images.forEach(src => {
        if (src) media.push({ type: "image", src });
      });
    }

    if (!media.length && currentVariant.featured_image?.src) {
      media.push({ type: "image", src: currentVariant.featured_image.src });
    }

    content.innerHTML = `
      <div class="cp-edit-gallery">
        <div class="cp-edit-flickity">
          ${media.map(m => {
            if (m.type === "video") {
              return `
                <div class="cp-edit-slide cp-edit-slide-video">
                  <video src="${m.src}" poster="${m.poster}"
                        playsinline muted loop preload="metadata"
                        controls></video>
                </div>
              `;
            }
            if (m.type === "external_video") {
              const embedUrl = m.host === "youtube"
                ? `https://www.youtube.com/embed/${m.externalId}?rel=0&playsinline=1`
                : `https://player.vimeo.com/video/${m.externalId}`;
              return `
                <div class="cp-edit-slide cp-edit-slide-video">
                  <iframe src="${embedUrl}" frameborder="0"
                          allow="autoplay; encrypted-media; picture-in-picture"
                          allowfullscreen></iframe>
                </div>
              `;
            }
            return `
              <div class="cp-edit-slide">
                <img src="${m.src}" alt="${product.title}" loading="lazy" draggable="false" />
              </div>
            `;
          }).join("")}
        </div>
        ${media.length > 1 ? `<div class="cp-edit-progress"><div class="cp-edit-progress-bar"></div></div>` : ""}
      </div>

      <div class="cp-edit-body">
        <h3 class="cp-edit-title">${product.title}</h3>
        <div class="cp-edit-rating" data-product-url="${product.url}"></div>
        ${buildEditOptionsHTML(product, selectedOptions)}
        <div class="cp-edit-footer">
          <div class="cp-edit-qty">
            <button type="button" class="cp-edit-qty-minus" aria-label="Decrease">−</button>
            <input type="number" min="1" value="${cartItem.quantity}" />
            <button type="button" class="cp-edit-qty-plus" aria-label="Increase">+</button>
          </div>
          <button type="button" class="cp-edit-update" data-line="${cartLine}">UPDATE</button>
        </div>
        <a href="${product.url}" class="cp-edit-viewfull">View product details</a>
      </div>
    `;

    initEditPanelLogic(product, content, panel, cartLine, currentVariant, selectedOptions);
  }

  function buildEditOptionsHTML(product, selectedOptions) {
    const isValueAvailable = (optIdx, value) => {
      return product.variants.some(v => {
        if (!v.available) return false;
        const opts = [v.option1, v.option2, v.option3];
        for (let i = 0; i < product.options.length; i++) {
          if (i === optIdx) { if (opts[i] !== value) return false; }
          else if (selectedOptions[i] && opts[i] !== selectedOptions[i]) return false;
        }
        return true;
      });
    };

    return product.options.map((opt, idx) => {
      const isColor = isColorOption(opt.name);
      const sel = selectedOptions[idx] || "";

      return `
        <div class="cp-edit-option ${isColor ? "is-color" : "is-pill"}">
          <div class="cp-edit-option-head">
            <span class="cp-edit-option-name">${(isColor ? "SELECTED " : "") + opt.name.toUpperCase()}:</span>
            <span class="cp-edit-option-value" data-opt-idx="${idx}">${sel}</span>
          </div>
          <div class="cp-edit-option-values" data-opt-idx="${idx}">
            ${opt.values.map(val => {
              const available = isValueAvailable(idx, val);
              const soldClass = available ? "" : "sold-out";
              const titleSuffix = available ? "" : " (Sold out)";
              return isColor
                ? `<button type="button" class="cp-edit-swatch ${val === sel ? "selected" : ""} ${soldClass}"
                          data-opt-idx="${idx}" data-value="${val}"
                          style="background:${colorNameToCSS(val)}"
                          aria-label="${val}${titleSuffix}" title="${val}${titleSuffix}"></button>`
                : `<button type="button" class="cp-edit-pill ${val === sel ? "selected" : ""} ${soldClass}"
                          data-opt-idx="${idx}" data-value="${val}">${val}</button>`;
            }).join("")}
          </div>
        </div>
      `;
    }).join("");
  }

  function initEditPanelLogic(product, content, panel, cartLine, initialVariant, initialOptions) {
    let currentVariant = initialVariant;
    let selectedOptions = initialOptions.slice();

    const flickityEl = qs(".cp-edit-flickity", content);
    const slides = qsa(".cp-edit-slide", content);
    const progressBar = qs(".cp-edit-progress-bar", content);
    let flkty = null;
    const titleEl = qs(".cp-edit-title", content);
    const updateBtn = qs(".cp-edit-update", content);
    const qtyInput = qs(".cp-edit-qty input", content);

    /* FLICKITY GALLERY */
    let currentSlide = 0;

    const goToSlide = (i) => {
      if (!flkty || !slides.length) return;
      flkty.select(i, false, false);
    };

    const initFlickity = () => {
      if (!window.Flickity) return;
      if (flkty) return;

      flkty = new Flickity(flickityEl, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        draggable: true,
        freeScroll: false,
        setGallerySize: false,
        adaptiveHeight: false
      });

      flkty.on("select", () => {
        currentSlide = flkty.selectedIndex;
        qsa("video", flickityEl).forEach(v => v.pause());
      });

      flkty.on("scroll", (progress) => {
        if (!progressBar) return;
        const clamped = Math.max(0, Math.min(1, progress));
        progressBar.style.width = (clamped * 100) + "%";
      });

      setTimeout(() => {
        flkty.resize();
        if (progressBar && slides.length > 1) {
          progressBar.style.width = (1 / slides.length * 100) + "%";
        }
      }, 50);
    };

    if (window.Flickity) {
      initFlickity();
    } else {
      loadCSS("https://unpkg.com/flickity@2.3.0/dist/flickity.min.css");
      loadScript("https://unpkg.com/flickity@2.3.0/dist/flickity.pkgd.min.js").then(() => {
        initFlickity();
      }).catch(err => console.error("Flickity load failed", err));
    }

    /* SWATCH / PILL CLICKS */
    const bindOptionClicks = () => {
      qsa(".cp-edit-swatch, .cp-edit-pill", content).forEach(btn => {
        btn.addEventListener("click", () => {
          const idx = parseInt(btn.dataset.optIdx, 10);
          selectedOptions[idx] = btn.dataset.value;

          const oldOptions = qsa(".cp-edit-option", content);
          oldOptions.forEach(el => el.remove());

          const ratingEl = qs(".cp-edit-rating", content);
          const anchor = ratingEl || titleEl;
          anchor.insertAdjacentHTML("afterend", buildEditOptionsHTML(product, selectedOptions));
          bindOptionClicks();

          updateCurrentVariant();
        });
      });
    };

    let isInitialRender = true;

    const updateCurrentVariant = () => {
      const v = product.variants.find(variant =>
        variant.options.every((o, i) => o === selectedOptions[i])
      );
      if (v) {
        currentVariant = v;
        if (!isInitialRender && v.featured_image && v.featured_image.src) {
          const targetFile = v.featured_image.src.split("?")[0].split("/").pop();
          const matchIdx = slides.findIndex(s => {
            const mediaEl = qs("img, video", s);
            const src = mediaEl?.src || mediaEl?.getAttribute("poster") || "";
            return src.includes(targetFile);
          });
          if (matchIdx >= 0) {
            if (flkty) goToSlide(matchIdx);
            else setTimeout(() => goToSlide(matchIdx), 300);
          }
        }
        updateBtn.disabled = !v.available;
        updateBtn.textContent = v.available ? "UPDATE" : "SOLD OUT";
      } else {
        currentVariant = null;
        updateBtn.disabled = true;
        updateBtn.textContent = "UNAVAILABLE";
      }
      isInitialRender = false;
    };

    bindOptionClicks();
    updateCurrentVariant();

    /* RATING — fetch product page and render stars */
    const ratingHolder = qs(".cp-edit-rating", content);
    if (ratingHolder && ratingHolder.dataset.productUrl) {
      ratingHolder.innerHTML = `<span class="cp-rating-loading">Loading reviews…</span>`;
      renderLooxBadge(ratingHolder, product.id, ratingHolder.dataset.productUrl);
    }

    /* QTY +/- */
    const qtyMinus = qs(".cp-edit-qty-minus", content);
    const qtyPlus = qs(".cp-edit-qty-plus", content);
    qtyMinus?.addEventListener("click", () => {
      const v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus?.addEventListener("click", () => {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    /* UPDATE BUTTON */
    let isUpdating = false;
    updateBtn.addEventListener("click", async () => {
      if (isUpdating || updateBtn.disabled) return;
      if (!currentVariant || !currentVariant.available) return;

      isUpdating = true;
      const originalText = updateBtn.textContent;
      updateBtn.disabled = true;
      updateBtn.innerHTML = `<span class="cp-edit-spinner"></span> Updating...`;

      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            line: cartLine,
            quantity: parseInt(qtyInput.value, 10) || 1,
            id: currentVariant.id
          })
        });

        if (!res.ok) {
          await fetch("/cart/change.js", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ line: cartLine, quantity: 0 })
          });
          await fetch("/cart/add.js", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: currentVariant.id, quantity: parseInt(qtyInput.value, 10) || 1 })
          });
        }

        await refreshCartDrawer();
        panel.classList.remove("active");
      } catch (err) {
        console.error("[edit-panel] update failed", err);
        updateBtn.disabled = false;
        updateBtn.textContent = originalText;
        isUpdating = false;
      }
    });
  }

  /* -----------------------------------
     GLOBAL CLICK HANDLER
  ----------------------------------- */

  doc.addEventListener("click", async e => {
    const quick = e.target.closest(".cp-quickview-btn");
    if (quick) {
      return openProductModal(quick.dataset.url);
    }

    const edit = e.target.closest(".cp-edit-btn");
    if (edit) {
      const url = edit.dataset.url;
      const line = edit.dataset.line;

      const product = await fetchJSON(url.split("?")[0] + ".js");
      if (!product) return;

      const titleLower = (product.title || "").toLowerCase();
      const isEngraving = titleLower.includes("engraving") || product.product_type === "engraving";
      const isGift = titleLower.includes("birthday") || titleLower.includes("gift") || product.product_type === "giftit";

      if (isEngraving || isGift) {
        return openProductModal(url, true, line);
      }

      return openEditPanel(url, line);
    }
  });

  /* -----------------------------------
     CART REFRESH
  ----------------------------------- */

  async function refreshCartDrawer() {
    try {
      destroyFeedbackSlider();
      const res = await fetch("/?sections=cart-drawer");
      const data = await res.json();
      const parser = new DOMParser();
      const html = parser.parseFromString(data["cart-drawer"], "text/html");
      const newDrawer = html.querySelector(".cart-drawer");
      const currentDrawer = document.querySelector(".cart-drawer");
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
      enhanceCartItems();
      initFeedbackSlider();
    } catch (err) {
      console.error("Cart refresh failed", err);
    }
  }

  /* -----------------------------------
     VARIANT LOGIC (for Quick View + engraving edit)
  ----------------------------------- */

  function initVariantLogic(product, container, isEdit, ctx = {}) {
    const selects = qsa(".cp-variants select", container);
    const priceWrap = qs(".cp-price", container);
    const img = qs("img", container);

    let currentVariant =
      product.variants.find(v => v.id === ctx.variantId) || product.variants[0];

    const addBtn    = qs(".cp-addtocart", container);
    const updateBtn = qs(".cp-updatecart", container);

    const withLoading = async (btn, fn) => {
      if (!btn || btn.disabled) return;
      const originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add("cp-btn-loading");
      btn.innerHTML = `<span class="cp-spinner"></span> Loading...`;
      try {
        await fn();
      } catch (err) {
        console.error(err);
        btn.disabled = false;
        btn.classList.remove("cp-btn-loading");
        btn.innerHTML = originalHTML;
      }
    };

    const updateView = () => {
      const v = getSelectedVariant(product, selects);
      if (v) {
        currentVariant = v;
        if (priceWrap) priceWrap.innerHTML = formatMoney(v.price);
        if (v.featured_image && img) img.src = v.featured_image.src;
      } else {
        if (priceWrap) priceWrap.innerHTML = "Unavailable";
      }
    };

    selects.forEach(sel => sel.addEventListener("change", updateView));

    const qtyInput = qs(".cp-qty input", container);
    const qtyMinus = qs(".cp-qty-minus", container);
    const qtyPlus  = qs(".cp-qty-plus", container);

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener("click", () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) qtyInput.value = current - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener("click", () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    if (addBtn) {
      addBtn.addEventListener("click", () => withLoading(addBtn, async () => {
        const qty = qs(".cp-qty input", container).value;
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: currentVariant.id, quantity: qty })
        });
        await refreshCartDrawer();
        document.querySelector(".cp-product-modal").classList.remove("active");
      }));
    }

    if (updateBtn) {
      updateBtn.addEventListener("click", () => withLoading(updateBtn, async () => {
        const cartLine = parseInt(updateBtn.dataset.line, 10);
        const qty = parseInt(qs(".cp-qty input", container).value, 10);

        const cart = await fetchJSON("/cart.js");
        const cartItem = cart?.items?.[cartLine - 1];
        if (!cartItem) throw new Error("Cart item not found");

        const variantId = currentVariant.id;
        const inputEl = qs(".cp-custom-input", container);
        const errorEl = qs(".cp-input-error", container);
        let inputValue = inputEl?.value.trim() || "";

        if (cartItem.product_type === "engraving") {
          inputValue = inputValue.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 3);
          if (inputEl) inputEl.value = inputValue;
          if (!inputValue) {
            if (errorEl) errorEl.style.display = "block";
            throw new Error("Empty engraving");
          } else if (errorEl) {
            errorEl.style.display = "none";
          }
        }

        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: cartLine, quantity: 0 })
        });

        const properties = {};
        if (cartItem.product_type === "engraving") properties["Engraving Text"] = inputValue;
        if (cartItem.product_type === "giftit")    properties["Gift Message"]   = inputValue;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: qty, properties })
        });

        await refreshCartDrawer();
        qs(".cp-product-modal").classList.remove("active");
      }));
    }
  }

})(); 




/* comparing the bags */
(function () {
  
  // Terms to match (the shorter ones already cover their longer variants)
  var terms = [
    'Hybrid Laptop Bag',
    'Hybrid Laptop',
    'Hybrid Bag',
    'Frame Messenger',
    'Fathom Briefcase',
    'Archive Laptop',
    'Noma Shoulder Bag',
    'Noma Shoulder',
    'Noma Bag'
  ];
  // Normalize: lowercase + turn any non-alphanumeric char into a single space
  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  // Grab the product title (adjust selector to your theme if needed)
  var titleEl = document.querySelector('.product-title, .product__title, [itemprop="name"], h1');
  var titleText = titleEl ? titleEl.textContent : '';
  // Haystack = product title + full URL
  var haystack = normalize(titleText + ' ' + window.location.href);
  var match = terms.some(function (term) {
    return haystack.indexOf(normalize(term)) !== -1;
  });



  /* =====================================
    section functionality - compare the bags 
  ===================================== */
  const compareId = "cp-product-compare";

  if (document.getElementById(compareId)) return;

  /* =====================================
      PRODUCT DATA
  ===================================== */
  const compareProducts = [
    {
      title: "Hybrid Laptop Bag",
      handle: "hybrid-laptop-bag-14-inches",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Hybrid_Laptop_bag_-_Capacity_Image.png?v=1776770732",
      capacityText: "Laptop 13”, Phone, <br>Charger, Mouse, Perfume",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" },
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Portfolio_sleeve_Icon_a950bd35-d994-4235-943b-a43b5e988e3c.png", text: "Portfolio sleeve" }
      ]
    },
    {
      title: "Frame Messenger Bag 14”",
      handle: "frame-messenger",
      variantId: "44417081737285",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Frame_Messenger_Bag_14_-_Capacity_Image.png?v=1776770732",
      capacityText: "Laptop 13”, Phone, <br>Charger, Mouse, Perfume",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" },
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Carry_Icon_f6304e52-3033-4f09-bc59-7929b96764e9.png?v=1776770719", text: "Carry" }
      ]
    },
    {
      title: "Frame Messenger Bag 11”",
      handle: "frame-messenger",
      variantId: "44417078132805",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Frame_Messenger_Bag_11_-_Capacity_Image.png?v=1776770731",
      capacityText: "iPad 11”, Phone, <br>Charger, Perfume",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" },
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Carry_Icon_f6304e52-3033-4f09-bc59-7929b96764e9.png?v=1776770719", text: "Carry" }
      ]
    },
    {
      title: "Fathom Briefcase 16”",
      handle: "fathom-briefcase",
      variantId: "44417088225349",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Fathom_Briefcase_16_-_Capacity_Image.png?v=1776770732",
      capacityText: "Laptop 16”, iPad 11”, Journal, <br>Phone, Charger, Mouse, Perfume",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" },
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Carry_Icon_f6304e52-3033-4f09-bc59-7929b96764e9.png?v=1776770719", text: "Carry" }
      ]
    },
    {
      title: "Fathom Briefcase 14”",
      handle: "fathom-briefcase",
      variantId: "44417088192581",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Fathom_Briefcase_14_-_Capacity_Image.png?v=1776770732",
      capacityText: "Laptop 14”, Phone, Charger, <br>Mouse, Perfume",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" },
        { image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Carry_Icon_f6304e52-3033-4f09-bc59-7929b96764e9.png?v=1776770719", text: "Carry" }
      ]
    },
    {
      title: "Archive Laptop Sleeve 16”",
      handle: "archive-laptop-sleeve-13-inches",
      variantId: "43970587426885",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Archive_Laptop_Sleeve_16_-_Capacity_Image.png?v=1776770731",
      capacityText: "Laptop 13”, Charger",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
      	{ image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Portfolio_sleeve_Icon_a950bd35-d994-4235-943b-a43b5e988e3c.png", text: "Portfolio sleeve" }
    	]
    },
    {
      title: "Archive Laptop Sleeve 14”",
      handle: "archive-laptop-sleeve-13-inches",
      variantId: "42081104461893",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Archive_Laptop_Sleeve_13_-_Capacity_Image.png?v=1776770731",
      capacityText: "Laptop 13”, Charger",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
      	{ image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Portfolio_sleeve_Icon_a950bd35-d994-4235-943b-a43b5e988e3c.png", text: "Portfolio sleeve" }
    	]
    },
    {
      title: "Noma Shoulder Bag",
      handle: "noma-shoulder-bag",
      capacityImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Noma_Shoulder_Bag_-_Capacity_Image.png?v=1776770732",
      capacityText: "Phone, Charger, Perfume, <br>Lipstick, Earbud",
      materialImage: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Material-Icon.png",
      materialText: "Next-Gen <br>Vegan Leather",
      wear: [
      	{ image: "https://cdn.shopify.com/s/files/1/0563/5401/3253/files/Crossbody_sling_-_Icon_5b8f4c91-765b-4062-aedb-5bbc6c20cc6c.png", text: "Crossbody sling" }
    	]
    }
  ];

  let selectedProducts = [
    compareProducts[0],
    compareProducts[1],
    compareProducts[3]
  ];

  /* =====================================
      HTML
  ===================================== */
  const section = document.createElement("section");
  section.id = compareId;

  section.innerHTML = `
    <div class="cp-container">
      <h2>Which one is for you</h2>
      <div class="cp-compare-wrap"></div>
    </div>
  `;

  /*
  const collapsibleContent = document.querySelector(".shopify-section .collapsible-content");
  const productFeaturesSection = document.querySelector(".product-featuresSlider-wrapper");

  const target = collapsibleContent || productFeaturesSection;;

  const targetRow = target.closest(".shopify-section");

  targetRow.insertAdjacentElement("afterend", section);
  */
  const sharkSection = document.querySelector(".cp-shark-section");
  const targetRow = sharkSection.closest(".shopify-section");

  const prevSibling = targetRow.previousElementSibling;

  if (prevSibling && prevSibling.classList.contains("metafield-cp-review-wrapper")) {
    prevSibling.insertAdjacentElement("beforebegin", section);
  } else {
    targetRow.insertAdjacentElement("beforebegin", section);
  }

  const wrap = section.querySelector(".cp-compare-wrap");

  /* =====================================
      HELPERS
  ===================================== */

  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js").then((r) => r.json());
  }

  function colorMap(name) {
    const val = name.toLowerCase();

    if (val.includes("black")) return "#111";
    if (val.includes("carbon")) return "#111";
    if (val.includes("midnight")) return "#111";
    if (val.includes("clay")) return "#d8cec4";
    if (val.includes("green")) return "#6f7658";
    if (val.includes("fir")) return "#6f7658";
    if (val.includes("blue")) return "#a8bfd1";
    if (val.includes("burgundy")) return "#7b2948";

    return "#ddd";
  }

  async function getProductData(product) {
    const json = await fetchProduct(product.handle);

    let selectedVariant = null;

    if (product.variantId) {
      selectedVariant = json.variants.find(
        (item) => String(item.id) === String(product.variantId)
      );
    }

    if (!selectedVariant) {
      selectedVariant =
        json.variants.find((item) => item.available) ||
        json.variants[0];
    }

    const swatches = [];
    const used = {};

    json.variants.forEach((variant) => {
      const color = variant.option1;

      if (!used[color]) {
        used[color] = true;

        swatches.push({
          name: color,
          image:
            (variant.featured_image &&
              (variant.featured_image.src ||
                variant.featured_image.url)) ||
            json.images[0]
        });
      }
    });

    return {
      product,
      image:
        (selectedVariant.featured_image &&
          (selectedVariant.featured_image.src ||
            selectedVariant.featured_image.url)) ||
        json.images[0],
      activeColor: selectedVariant.option1,
      swatches: swatches
    };
  }

  function headingRow(title) {
    return `
      <div class="cp-heading-row ${title}">
        <h3>${title}</h3>
      </div>
    `;
  }

  /* =====================================
      RENDER
  ===================================== */

  async function renderCompare() {
    const productsData = await Promise.all(
      selectedProducts.map((item) => getProductData(item))
    );

    wrap.innerHTML = `
      
      <!-- FIRST ROW -->
      <div class="cp-first-row cp-grid-3">
        ${productsData
          .map(
            (item, index) => `
          <div class="cp-col cp-first-product-image-select">
            <img src="${item.image}" class="cp-main-image" data-index="${index}">
            
            <select class="cp-select" data-index="${index}">
              ${compareProducts
                .map(
                  (p) => `
                <option value="${p.title}" ${
                    p.title === item.product.title
                      ? "selected"
                      : ""
                  }>
                  ${p.title}
                </option>
              `
                )
                .join("")}
            </select>
          </div>
        `
          )
          .join("")}
      </div>

      ${headingRow("Colours")}

      <!-- SECOND ROW -->
      <div class="cp-second-row cp-grid-3">
        ${productsData
          .map(
            (item, index) => `
          <div class="cp-col">
            <div class="cp-swatches" data-index="${index}">
              ${item.swatches
                .map(
                  (swatch) => `
                <span 
                  class="cp-swatch ${
                    swatch.name === item.activeColor
                      ? "active"
                      : ""
                  }"
                  data-index="${index}"
                  data-image="${swatch.image}"
                  style="background:${colorMap(
                    swatch.name
                  )}">
                </span>
              `
                )
                .join("")}
            </div>

            <div class="cp-color-name">
              ${item.swatches
                .map((x) => x.name)
                .join(", ")}
            </div>
          </div>
        `
          )
          .join("")}
      </div>

      ${headingRow("Capacity")}

      <!-- THIRD ROW -->
      <div class="cp-third-row cp-grid-3">
        ${productsData
          .map(
            (item) => `
          <div class="cp-col cp-info-block">
            <img src="${item.product.capacityImage}">
            <p>${item.product.capacityText}</p>
          </div>
        `
          )
          .join("")}
      </div>

      ${headingRow("Material")}

      <!-- FOURTH ROW -->
      <div class="cp-fourth-row cp-grid-3">
        ${productsData
          .map(
            (item) => `
          <div class="cp-col cp-info-block">
            <img src="${item.product.materialImage}">
            <p>${item.product.materialText}</p>
          </div>
        `
          )
          .join("")}
      </div>

      ${headingRow("Ways to wear")}

      <!-- FIFTH ROW -->
      <div class="cp-fifth-row cp-grid-3">
        ${productsData
          .map(
            (item) => `
          <div class="cp-col cp-wear-list">
            ${item.product.wear
              .map(
                (wear) => `
              <div class="cp-wear-item">
                <img src="${wear.image}">
                <span>${wear.text}</span>
              </div>
            `
              )
              .join("")}
          </div>
        `
          )
          .join("")}
      </div>
    `;

    bindEvents();
  }

  /* =====================================
      EVENTS
  ===================================== */

  function bindEvents() {
    /* dropdown */
    wrap.querySelectorAll(".cp-select").forEach((select) => {
      select.addEventListener("change", function () {
        const index = Number(this.dataset.index);

        const found = compareProducts.find(
          (item) => item.title === this.value
        );

        if (!found) return;

        selectedProducts[index] = found;

        renderCompare();
      });
    });

    /* swatches */
    wrap.querySelectorAll(".cp-swatch").forEach((swatch) => {
      swatch.addEventListener("click", function () {
        const index = this.dataset.index;
        const image = this.dataset.image;

        const img = wrap.querySelector(
          '.cp-main-image[data-index="' + index + '"]'
        );

        if (img) img.src = image;

        wrap
          .querySelectorAll(
            '.cp-swatch[data-index="' + index + '"]'
          )
          .forEach((item) =>
            item.classList.remove("active")
          );

        this.classList.add("active");
      });
    });
  }


  if (match) {
    document.body.classList.add('show-compare');
    /* =====================================
        INIT
    ===================================== */
    renderCompare();
  }
})();
